import React, { PureComponent } from 'react';
import ExpandToggleButton from '../../../../treeComponents/component/ExpandToggleButton';
import { getChapterNumber, isLastChapter } from '../../../../treeComponents/helper';
import { connect } from 'react-redux';
import _ from 'lodash';
import PreviewTest from './PreviewTest';



interface ChapterNodeProps {
  data: any;
  handleExpandNode: Function;
  isExpanded: boolean;
  subjectTab:string;
  treeData: any;
  viewPlanData: any;
}

class ChapterNode extends PureComponent<ChapterNodeProps> {
  componentWillUnmount() {
    if (this.props.isExpanded) {
      this.props.handleExpandNode();
    }
  }
  render = () => {
    const { data, handleExpandNode, isExpanded, viewPlanData, subjectTab } = this.props;
    const { name = '', subjectName, concepts, phaseIndex, weekIndex } = data;
    const hasValidChildren = concepts && concepts.length;
    const currentWeek = viewPlanData.phases[phaseIndex].weeks[weekIndex];
    return (
      <span>
      <div>
        <span style={{display: 'flex', alignItems: 'center'}}>
          {hasValidChildren ? (
            <ExpandToggleButton handleClick={handleExpandNode} isExpanded={isExpanded} />
          ) : (
            <></>
          )}
          <div style={{ fontSize: '18px', color: '#333', verticalAlign: 'middle', marginLeft: '10px' }}>
              {/* CH{getChapterNumber(subjectTab, data, viewPlanData)}.  */}
              {name} &nbsp;   <span style={{ fontSize: '14px', color: '#666' }}>({subjectName})</span></div>
        </span>
      </div>
        {/* render main tests */}
        {/* {isLastChapter(viewPlanData, data, subjectTab) && currentWeek.content.length ? (
          currentWeek.content.map((test: any) =>
            (<PreviewTest test={test} isWeek={true} />)
          )
        ) :
          <></>
        } */}
      </span>
    );
  };
}
const mapStateToProps = (state: any) => ({
  treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
  viewPlanData: _.get(state, 'courseMangementData.contentManagementData.viewPlanData', {}),
});

export default connect(mapStateToProps)(ChapterNode);
